module.exports = __webpack_public_path__ + "img/68ne.dd2876f2.svg";